<template>
    <div class="loginContainer">
        <h2>修改密码</h2>
        <div class="forms">
            <input type="password" placeholder="请输入新密码" v-model="psw" @input="inpChange">
            <input type="password" placeholder="确认密码" v-model="confirmPsw" @input="inpChange">
            <p v-show="isError">{{message}}</p>
            <div @click="changePwd">立即修改</div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            psw: "",
            confirmPsw: "",
            message: "",
            isError: false
        }
    },
    computed: {

    },
    created() {
        
    },
    methods: {
        changePwd() {
            let that = this;
            if( that.psw == "" ) {
                that.isError = true;
                that.message = "密码不能为空";
            }else if( that.confirmPsw == "" ){
                that.isError = true;
                that.message = "确认密码不能为空";
            }else if( that.psw !== that.confirmPsw ){
                that.isError = true;
                that.message = "两次密码输入不一致";
            }else {
                let data = new FormData();
                data.append("loginName", localStorage.getItem("userName"));
                data.append("password", that.confirmPsw);
                data.append("ticket", localStorage.getItem("ticket"));
                that.allApi.changePasd(data).then((resource) => {
                    // console.log(resource.data);
                    if( resource.data.code == 0 ) {
                        let that = this;
                        that.$router.push("/self");
                    }else{
                        that.isError = true;
                        that.message = resource.data.msg;
                    }
                })
            }
        },
        inpChange() {
            var that = this;
            that.isError = false;
        },
    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.loginContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    background: #fff;
    overflow: hidden;
    
    >h2{
        margin: rem(90px) 0;
        text-align: center;
        font-size: rem(40px);
    }
    .forms{
        padding: 0 rem(64px);
        margin-bottom: rem(65px);
        position: relative;
        input{
            display: block;
            width: 100%;
            height: rem(100px);
            font-size: rem(28px);
            border: 0;
            border-bottom: 1px solid #e5e5e5;
            outline: none;
            color: #999;
            line-height: rem(100px);
            &:focus{
                color: #999;
            }
        }
        >p{
            position: absolute;
            left: rem(64px);
            top: rem(200px);
            color: #e75652;
            margin-top: rem(30px);
        }
        >div{
            margin-top: rem(120px);
            color: #fff;
            background: #007AFF;
            border-radius: rem(90px);
            line-height: rem(90px);
            text-align: center;
            font-size: rem(36px);
        }
    }
}
</style>
